export const Support = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.95768 8.12533V7.91699C3.95768 4.81039 6.66263 2.29199 9.99935 2.29199C13.3361 2.29199 16.041 4.81039 16.041 7.91699V8.12533M9.99935 16.3694V16.8753C9.99935 17.3356 10.3724 17.7087 10.8327 17.7087H12.4993C14.5704 17.7087 16.2493 16.0297 16.2493 13.9587M3.54102 8.12533H4.79102V13.542H3.54102C2.85066 13.542 2.29102 12.9823 2.29102 12.292V9.37533C2.29102 8.68497 2.85066 8.12533 3.54102 8.12533ZM15.2077 8.12533H16.4577C17.148 8.12533 17.7077 8.68497 17.7077 9.37533V12.292C17.7077 12.9823 17.148 13.542 16.4577 13.542H15.2077V8.12533Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Support
